export const COMPLAINT_SERVICES = [
  "Beneficiary Services",
  "Aid / Assistance Request",
  "Financial Assistance",
  "Medical Assistance",
  "Education Assistance",
  "Housing / Rent Assistance",
  "Utility / Electricity Assistance",
  "Food / Basic Needs Assistance",
  "Donation Services",
  "Donation Payment",
  "Donation Receipt",
  "Request Status / Follow-up",
  "Application / Registration",
  "UAE PASS / Account Access",
  "Website / Mobile Application",
  "Rahma AI / Chatbot",
  "Customer Service / Support",
  "Volunteer Services",
  "Other",
];
